import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import { Tab } from "../../../../Reusablecomponents/Tab";
import {
  Badge,
  Button,
  Col,
  Row,
  Avatar,
  Checkbox,
  Popover,
  Tooltip,
  Space,
  Form,
  message,
  Spin,
  Select,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as CopyIcon } from "../../../../assets/images/Vector.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/Editicon.svg";
import { ReactComponent as Gps } from "../../../../assets/images/gps-svgrepo-com.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/delete-icon.svg";
import FilterIcon from "../../../../assets/images/Filter-Icon.svg";
import SortIcon from "../../../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../../../assets/images/download1.svg";
import ExportIcon from "../../../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../../../Reusablecomponents/UIModal";
import TripCode from "../Trip List Operation/TripCode";
import { CALL_API } from "../../../../Common/api";
import { useSelector } from "react-redux";
import {
  chargetype,
  priorityType,
  TripStatusEnum,
  TripTypeEnum,
} from "../../../../Common/constant";
import moment from "moment";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { render } from "@testing-library/react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactComponent as Track } from "../../../../assets/images/gps-svgrepo-com.svg";
import ReusablePagination from "../../../../Reusablecomponents/ReusablePagination";
export const WrapperBox = styled.div`
  .consingment_container_one {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    }
    .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }

  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;
const TableStyle = styled.div`
  .inactive-status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e4a400;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2c963d;
  }

  .yellow-dot {
    width: 4px;
    height: 4px;
    background-color: #e4a400;
    border-radius: 50%;
  }
`;

const TripList1 = () => {
  const csvLinkEl = useRef();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const handleTrackClick = (TripId) => {
    window.open(
      `/tracklink/${TripId}?MCID=${userInfo?.MCID}`,
      "_blank",
      "noopener,noreferrer",
    );
  };
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const [customFields, setCustomFields] = useState([]);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [formData, setFormData] = useState({
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const location = useLocation();
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("TRIP", "ET"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("TRIP", "DT"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("TRIP", "EX"),
    [reduxPermissions],
  );
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );

  const [form] = Form.useForm();

  const duration = Form.useWatch("duration", form);

  useEffect(() => {
    if (duration === "last_month") {
      const range = [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ];
      form.setFieldValue("daterange", range);
      setFormData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "current_month") {
      const range = [dayjs().startOf("month"), dayjs().endOf("month")];
      form.setFieldValue("daterange", range);
      setFormData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "current_year") {
      const range = [dayjs().startOf("year"), dayjs().endOf("year")];
      form.setFieldValue("daterange", range);
      setFormData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "today") {
      const range = [dayjs(), dayjs()];
      form.setFieldValue("daterange", range);
      setFormData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "---") {
      const range = [null, null];
      form.setFieldValue("daterange", range);
      setFormData((prev) => ({ ...prev, daterange: range }));
    }
  }, [duration]);

  const [visibleExport, setVisibleExport] = useState(false);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };
  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };
  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [deleteloading, setDeleteLoading] = useState(false);
  const [consignee, setConsignee] = useState(null);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tripList, setTripList] = useState([]);
  const [assignedCount, setAssignedCount] = useState([]);
  const [completedCount, setCompletedCount] = useState([]);
  const [inProgressCount, setInProgreeCount] = useState([]);
  const [tripId, setTripId] = useState(null);
  const [singleTrip, setSingleTrip] = useState(null);
  const [filterCount, setFilterCount] = useState(0);
 
  const [isEditing, setIsEditing] = useState(false);
  const showDrawer = () => {
    setIsEditing(false);
    setFormData({
      consignor: "",
      transporter: "",
      consignee: "",
      chargetype: "",
      priority: "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: "",
      plocation: "",
      pdate: "",
      dlocation: "",
      ddate: "",
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
    });
    setDrawerOpen(true);
  };

  const editUser = (record) => {
    setIsEditing(true);
    setDrawerOpen(true);
    setEditformdata({
      ...record,
      triptype: record?.Triptype,
      odostart: record?.ODOSTART,
      odoend: record?.ODOEND,
      remarks: record?.REMARKS,
      finalquantity: "",
      tripallowance: "",
    });
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);

  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
  const editModuleupdate = () => {
    // form.resetFields();
    setFormData({
      driver: "",
      consignor: "",
      vehicle: "",
      consignee: "",
      transporter: "",
      consignmentevent: "",
      tripcode: "",
      triptype: "",
      duration: "current_month",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
    form.setFieldsValue({
      driver: "",
      consignor: "",
      vehicle: "",
      consignee: "",
      transporter: "",
      consignmentevent: "",
      tripcode: "",
      triptype: "",
      duration: "current_month",
      daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    });
  };
  const [sortField, setSortField] = useState(null);

  const handleSortOptionChange = (value) => {};
  const [formType, setFormType] = useState("addEdit"); // 'addEdit' or 'bulkCreate'

  const handleCreateClick = () => {
    setFormType("addEdit");
    setDrawerOpen(true);
  };
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const GetAllCustomeData = async () => {
    // setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Trip`,
      );
      SetAllCustomeData(data);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // const handlePageChange = (page, pageSize) => {
  //   setCurrentPage(page);
  //   setPageSize(pageSize);
  // };

  // const handlePageSizeChange = (value) => {
  //   setPageSize(value);
  //   setCurrentPage(1);
  // };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

   const handleChange = (e) => {
    const { value, name } = e.target;
    setCurrentPage(1);
    setFormData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };

  const fetchTripListData = async () => {
    try {
      setLoading(true); // Start the spinner
      const { data } = await CALL_API("POST", `trip/getAllTrip`, {
        mcId: userInfo?.MCID,
        driver: formData?.driver || "",
        custName: formData?.consignor || "",
        regNo: formData?.vehicle || "",
        recName: formData?.consignee || "",
        supName: formData?.transporter || "",
        status: formData?.consignmentevent,
        code: formData?.tripcode || "",
        tripType: formData?.triptype || "",
        dateFrom:
          dayjs(formData?.daterange?.[0]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        dateTo:
          dayjs(formData?.daterange?.[1]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        offset: currentPage,
        perPage: pageSize,
      });
      const newData1 = data?.data?.map((tripItem) => {
        const enrichedItem = { ...tripItem };

        // Match fields by REFID === TRIPID
        const matchedFields =
          AllCustomeData?.filter((field) => field.REFID === tripItem.TRIPID) ||
          [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setTripList(newData1 || []);
      setAssignedCount(data?.assignedCount || 0);
      setInProgreeCount(data?.inProgressCount || 0);
      setCompletedCount(data?.completedCount || 0);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching trip list data:", error);
      message.error("Failed to fetch trip list data.");
    } finally {
      setLoading(false); // Stop the spinner only after data is processed
    }
  };

  const getSingletripData = async () => {
    //  setLoading(true);
    const { data } = await CALL_API("POST", `trip/getSingleTripById`, {
      tripId: tripId,
    });
    setSingleTrip(data);
    setLoading(false);
  };

  const handleclickdeleteAi = async (id) => {
    setDeleteLoading(true);

    try {
      const { ResponseCode, message: apiMessage } = await CALL_API(
        "DELETE",
        `trip/deleteTrip/${id}`,
      );

      if (ResponseCode === 200) {
        await fetchTripListData();
        setConsignee(false);
        setIsDeleteModalVisible(false);
        setDeleteId(null);
        message.success(apiMessage || "Trip Deleted Successfully");
      }
    } finally {
      setDeleteLoading(false);
    }
  };
  useEffect(() => {
    fetchTripListData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);

      const { data } = await CALL_API("POST", `/trip/getAllTrip`, {
        mcId: userInfo?.MCID,
        driver: formData?.driver || "",
        custName: formData?.consignor || "",
        regNo: formData?.vehicle || "",
        recName: formData?.consignee || "",
        supName: formData?.transporter || "",
        status: formData?.consignmentevent,
        code: formData?.tripcode || "",
        tripType: formData?.triptype || "",
        dateFrom:
          dayjs(formData?.daterange?.[0]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        dateTo:
          dayjs(formData?.daterange?.[1]).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        offset: 1,
        perPage: total,
      });

      const tripData = data?.data || [];
      const customFieldMap = Object.fromEntries(
        (customFields || []).map((f) => [f.CFID, f.FIELDNAME]),
      );
      const enrichedTrips = tripData.map((tripItem) => {
        const baseData = {
          Date: tripItem.Started
            ? dayjs(tripItem.Started).format("DD/MM/YYYY")
            : "-",
          "Trip Code": tripItem.CODE || tripItem.Code || "-",
          "Vehicle/Driver": `${tripItem.RegNo || "-"} / ${
            tripItem.DriverName || "-"
          }`,
          Status:
            TripStatusEnum.find((s) => s.value === tripItem.STATUS)?.label ||
            "-",
          Consignor: tripItem.CustName || "-",
          Consignee: tripItem.SupName || tripItem.RecName || "-",
          Consign: tripItem.ConsignmentCount || 0,
          "ODO(KMS)":
            tripItem.ODOEND != null && tripItem.ODOSTART != null
              ? Number(tripItem.ODOEND) - Number(tripItem.ODOSTART)
              : 0,
          "Trip Time":
            getTripDuration(tripItem.FirstEventTime, tripItem.LastEventTime) ||
            0,
          "Carbon Footprint": tripItem.CarbonFootprint || "-",
        };
        const matchedFields =
          AllCustomeData?.filter((f) => f.REFID === tripItem.TRIPID) || [];

        const customFieldValues = {};
        matchedFields.forEach((f) => {
          const fieldName = customFieldMap[f.CFID] || `Custom_${f.CFID}`;
          customFieldValues[fieldName] = f.VALUE || "";
        });
        return { ...baseData, ...customFieldValues };
      });
      setCSVList(enrichedTrips);
      setTimeout(() => csvLinkEl.current.link.click(), 500);
    } catch (error) {
      console.error("Error preparing CSV:", error);
      message.error("Failed to prepare CSV data.");
    } finally {
      setCSVLoader(false);
    }
  };

  const loadCustomFields = async () => {
    // setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Trip",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (TRIPID, values) => {
    setLoading(true);
    try {
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        const existing = AllCustomeData?.find(
          (item) => item.REFID === TRIPID && item.CFID === field.CFID,
        );

        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: TRIPID,
            Value: value,
            DataId: existing.DATAID,
          };
          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (TRIPID) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: TRIPID,
          RefTab: "Trip",
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  // const formattedTime = (minutes) =>{
  // let b = `${String(dayjs.duration(minutes, 'minutes').hours()).padStart(2, '0')}:${String(dayjs.duration(minutes, 'minutes').minutes()).padStart(2, '0')}`;
  // return b
  // }
  const getTripDuration = (start, end) => {
    if (!start || !end) return "-";

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (isNaN(startDate) || isNaN(endDate)) return "-";

    let diff = endDate - startDate;
    if (diff <= 0) return "-";

    const totalMinutes = Math.floor(diff / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    if (days > 0) {
      return `${days}d(${formattedHours}:${formattedMinutes})`;
    } else {
      return `${formattedHours}:${formattedMinutes}`;
    }
  };

  const [sortFields, setSortFields] = useState([]);
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.CFID,
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  const columns = [
    {
      title: "Date",
      dataIndex: "Started",
      key: "Started",
      render: (value) => {
        return value ? dayjs(value).format("DD/MM/YYYY") : "---";
      },
    },
    {
      title: "Trip Code",
      dataIndex: "CODE",
      key: "CODE",
      sorter: sortFields?.includes("CODE") // remove leading space!
        ? (a, b) => (a.CODE ?? 0) - (b.CODE ?? 0)
        : false,
      // render: (text, record) => {
      //   return (
      //     <div>
      //       <p>{text}</p> {/* Render the Trip Code */}
      //       <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      //         <span
      //           style={{
      //             width: "4px",
      //             height: "4px",
      //             borderRadius: "50%",
      //             backgroundColor:
      //               record?.TripType === 1 ? "#5F6D8C" : "#E4A400", // Local: Default color, Safari: #E4A400
      //           }}
      //         ></span>
      //         <span
      //           style={{
      //             color: record?.TripType === 1 ? "#5F6D8C" : "#E4A400", // Local: Default color, Safari: #E4A400
      //             fontStyle: record?.TripType === 1 ? "italic" : "normal", // Italic for Local, normal for Safari
      //           }}
      //         >
      //           {tripList?.TripType === 1 ? "Local" : "Safari"}
      //         </span>
      //       </div>
      //     </div>
      //   );
      // },

      render: (text, record) => {
        return (
          <div>
            <p>{text}</p> {/* Render the Trip Code */}
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span
                style={{
                  width: "4px",
                  height: "4px",
                  borderRadius: "50%",
                  backgroundColor:
                    record?.Triptype === 1 ? "#5F6D8C" : "#E4A400", // Local: blueish, Safari: yellow
                }}
              ></span>
              <span
                style={{
                  color: record?.Triptype === 1 ? "#5F6D8C" : "#E4A400",
                  fontStyle: record?.Triptype === 1 ? "italic" : "normal",
                }}
              >
                {record?.Triptype === 1 ? "Local" : "Safari"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Vehicle/Driver",
      dataIndex: "RegNo",
      key: "RegNo",
      sorter: sortFields?.includes("RegNo")
        ? (a, b) => a.RegNo?.localeCompare(b.RegNo)
        : false,
      render: (text, record) => {
        return (
          <div>
            {record?.RegNo || "-"} <br /> {record?.DriverName || "-"}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "STATUS",
      key: "STATUS",
      render: (status, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            cursor: "pointer",
          }}
        >
          {/* Status Label */}
          <span style={{ color: status === 4 ? "green" : "#E4A400" }}>
            {TripStatusEnum.find((item) => item.value === status)?.label || "-"}
          </span>

          {/* Track Icon and Text for In Progress and Completed */}
          {status === 3 || status === 4 ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleTrackClick(record?.TRIPID, userInfo?.MCID);
              }}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <Track />
              <span style={{ color: "#2C963D" }}>Track</span>
            </div>
          ) : (
            <span style={{ color: "#5F6D8C" }}></span>
          )}
        </div>
      ),
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      sorter: sortFields?.includes("CustName")
        ? (a, b) => a.CustName?.localeCompare(b.CustName)
        : false,
    },
    {
      title: "ODO KMS",
      dataIndex: "ODOSTART",
      key: "ODOSTART",
      render: (_, record) => {
        const { ODOSTART, ODOEND } = record;
        return (
          <span>
            {" "}
            {record?.ODOSTART !== null && record?.ODOEND !== null
              ? Math.abs(ODOSTART - ODOEND)
              : 0}
          </span>
        );
      },
    },

    {
      title: "Transporter",
      dataIndex: "SupName",
      key: "SupName",
      sorter: sortFields?.includes("SupName")
        ? (a, b) => a.SupName?.localeCompare(b.SupName)
        : false,
    },

    {
      title: "Consign",
      dataIndex: "ConsignmentCount",
      key: "ConsignmentCount",
      render: (_, record) => {
        return (
          <span>
            {record.ConsignmentCount ? record.ConsignmentCount : "---"}
          </span>
        );
      },
    },
    {
      title: "Trip Time",
      dataIndex: "TravelMinutes",
      key: "TravelMinutes",
      render: (_, record) => {
        const { FirstEventTime, LastEventTime } = record;

        const tripDuration = getTripDuration(FirstEventTime, LastEventTime);

        return <span>{tripDuration}</span>;
      },
    },
    {
      title: "Carbon Footprint",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div
          className={
            hoveredrow === record.key ? "d-flex gap-3 opacity-100" : "opacity-0"
          }
        >
          <Tooltip title={!updateAllowed ? "No permission" : ""}>
            <EditIcon
              style={{ cursor: updateAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!updateAllowed) return;
                e.stopPropagation();
                editUser(record);
              }}
            />
          </Tooltip>
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <DeleteIcon
              style={{
                cursor: deleteAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                setDeleteId(record?.TRIPID); // Set the ID of the consignment to delete
                setIsDeleteModalVisible(true); // Show the delete confirmation modal
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  // Custom fields (selectable)
  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];

  const allColumnOptions = [...customFieldOptions];
  //combained column with custom fields and columns
  const combinedColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) {
      return columns; // Return default columns if no custom fields
    }

    const dynamicCols = customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...dynamicCols];
  }, [customFields]);

  const displayedColumns = useMemo(() => {
    const defaultCols = [...columns];
    const customCols = combinedColumns.filter((col) =>
      selectedColumns.includes(col.key),
    );
    const transporterIdx = defaultCols.findIndex(
      (col) => col.key === "SupName",
    );
    const actionsIdx = defaultCols.findIndex((col) => col.key === "actions");
    const beforeTransporter = defaultCols.slice(0, transporterIdx + 1);
    const afterTransporter = defaultCols.slice(transporterIdx + 1, actionsIdx);
    const actionsCol = defaultCols.slice(actionsIdx);
    return [
      ...beforeTransporter,
      ...customCols,
      ...afterTransporter,
      ...actionsCol,
    ];
  }, [columns, combinedColumns, selectedColumns]);

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const [editformdata, setEditformdata] = useState({});
  const [editripdata, setedittripdata] = useState([]);

  const edittrip = async () => {
    try {
      const { data } = await CALL_API("POST", `trip/updateInsert`, {
        Code: editformdata?.CODE,
        Remarks: editformdata?.remarks,
        Driver: driverList?.find(
          (val) => val?.FULLNM === editformdata?.DriverName,
        )?.UID,
        VehId: editformdata?.VEHID,
        Status: 4,
        CrBy: userInfo?.UID,
        TripType: editformdata?.triptype,
        TripId: editformdata?.TRIPID,
        ODOStart: editformdata?.odostart,
        ODOEnd: editformdata?.odoend,
      });
      await CustomeDataUpdate(editformdata?.TRIPID, editformdata);
      fetchTripListData();
      setDrawerOpen(false);
    } catch (error) {}
  };

  // useEffect(() => {
  //   edittrip();
  // }, []);
  const handleSelectChangeedit = (field, value) => {};

  const handleChangeedit = (e) => {
    const { value, name } = e.target;

    setEditformdata((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: "Trip Type",
          type: "selectwithvalue",
          name: "triptype",
          placeholder: "GCS",
          style: "",
          options: TripTypeEnum?.map((item) => ({
            label: item?.name,
            value: item?.value,
          })),
          validationRules: [
            { required: true, message: "Trip Type is required" },
          ],
        },
        {
          id: 2,
          label: "ODO Start",
          type: "text",
          name: "odostart",
          placeholder: "Cargo",
          style: "",
          options: transporterList?.map((item) => ({
            label: item?.Name,
            value: item?.ID,
          })),
          validationRules: [
            { required: true, message: "ODO Start is required" },
          ],
        },
        {},
        {},
      ],
      [
        {
          id: 3,
          label: "ODO End",
          type: "text",
          name: "odoend",
          placeholder: "TQS Agency",
          style: "",
          options: transporterList?.map((item) => ({
            label: item?.Name,
            value: item?.ID,
          })),
          validationRules: [{ required: true, message: "ODO End is required" }],
        },
        {},
        {},
        {},
      ],
      [
        {
          id: 4,
          label: "Remarks",
          type: "textarea",
          name: "remarks",
          placeholder: "Daily Rate",
          style: "",
          validationRules: [
            { required: false, message: "Remarks is required" },
          ],
          colSpan: 24,
        },
        {},
      ],
      [
        {
          id: 5,
          label: "Fuel Quantity",
          type: "text",
          name: "finalquantity",
          placeholder: "High",
          style: "",
          options: priorityType?.map((item) => ({
            label: item?.name,
            value: item?.value,
          })),
          validationRules: [
            { required: false, message: "Fuel Quantity is required" },
          ],
        },
        {
          id: 6,
          label: "Trip Allowance",
          type: "text",
          name: "tripallowance",
          placeholder: "3",
          validationRules: [
            { required: false, message: "Trip Allowance is required" },
          ],
          style: "",
        },
        {},
        {},
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const tripType = [
    {
      label: "Local",
      value: 1,
    },
    { label: "Safari", value: 2 },
  ];
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];
  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const editSelectChange = (field, value) => {
    setEditformdata((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Trip Code</span>,
              type: "text",
              name: "tripcode",
              placeholder: "234123",
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Trip Type</span>,
              type: "selectwithvalue",
              name: "triptype",
              placeholder: "Local",
              allowClear: true,
              maxLength: 50,
              options: tripType?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              allowClear: true,
              placeholder: "KA23134",
              maxLength: 50,
              options: vehicleList?.map((item) => ({
                label: item.REGNO,
                value: item.REGNO,
              })),
            },
            {
              id: 4,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              allowClear: true,
              placeholder: "Thomas",
              maxLength: 50,
              options: driverList?.map((item) => ({
                label: item.FULLNM,
                value: item.FULLNM,
              })),
            },
          ],
          [
            {
              id: 5,
              label: (
                <span style={{ color: "#5F6D8C" }}>Consignment Event</span>
              ),
              type: "selectwithvalue",
              name: "consignmentevent",
              placeholder: "Accepted",
              maxLength: 50,
              allowClear: true,
              options: TripStatusEnum?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Consignor</span>,
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "Accepted",
              allowClear: true,
              maxLength: 50,
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              id: 7,
              label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Accepted",
              allowClear: true,
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Consignee</span>,
              type: "selectwithvalue",
              name: "consignee",
              placeholder: "TQS Agency",
              maxLength: 50,
              allowClear: true,
              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",
              placeholder: "Current Month",
              maxLength: 50,
              allowClear: true,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 10,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: "24th Aug 2024 - 24th Sep 2024",
              maxLength: 50,
            },
            {},
            {},
          ],
        ],
      },
    ],
  };

  const handleclick = (record) => {
    setConsignee(true);
  };

  const handleSubmitForm = async () => {};

  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };

  const allOptions = ["CODE", "RegNo", "CustName", "SupName"];
  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };

  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <Checkbox
          indeterminate={
            sortFields.length > 0 && sortFields.length < allOptions.length
          }
          onChange={onCheckAllChange}
          checked={sortFields.length === allOptions.length}
        >
          All
        </Checkbox>

        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            <Checkbox value="CODE">Trip Code</Checkbox>
            <Checkbox value="RegNo">Vehicle</Checkbox>
            <Checkbox value="CustName">Consignor</Checkbox>
            <Checkbox value="SupName">Consignee</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );

  useEffect(() => {
    GetAllCustomeData();
  }, []);

  useEffect(() => {
    if (AllCustomeData && AllCustomeData.length > 0) {
      loadCustomFields();
    }
  }, [AllCustomeData]);

  useEffect(() => {
      fetchTripListData();
  }, [customFields,
    formData?.driver,
    formData?.consignor,
    formData?.vehicle,
    formData?.consignee,
    formData?.transporter,
    formData?.consignmentevent,
    formData?.tripcode,
    formData?.triptype,
    formData?.daterange,
  ]);

  useEffect(() => {
    const count = Object.values(formData).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count - 1);
    // getSingletripData();
  }, [formData]);

  useEffect(() => {
    if (location?.state?.from === "consignment" && location?.state?.tripId) {
      setConsignee(true);
      setSelectededittwo(location?.state?.consignmentRecord);
      setTripId(location?.state?.tripId);
    }
  }, [location?.state?.tripId]);

  const [selectededittwo, setSelectededittwo] = useState();
  const isDataReady =
    typeof loading !== "undefined"
      ? !loading
      : Boolean(total || completedCount || inProgressCount || assignedCount);

  return (
    <>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  <span
                    style={{
                      color: "#2C963D",
                      fontWeight: "400",
                      fontSize: "20px",
                    }}
                  ></span>
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleChange}
            formSubmit={handleSubmitForm}
            initialValues={formData}
            form={form}
            handleSelectChange={handleSelectChange}
          />
        </WrapperBox>
      </UIModal>

      {consignee ? (
        <>
          <TripCode
            getSingletripDatafortriplist={getSingletripData}
            fetchTripListData={fetchTripListData}
            setDrawerOpen={setDrawerOpen}
            setConsignee={setConsignee}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawerOpen={drawerOpen}
            formData={formData}
            WrapperBox={WrapperBox}
            tripId={tripId}
            selectededittwo={selectededittwo}
            editUser={editUser}
          />
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}></Col>
                </Row>
              </Col>
            </Row>

            {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
              <Row gutter={16}>
                <Col xs={24} xl={24}>
                  <div className="consingment_container_one">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <p style={{ margin: 0 }}>{total} Trips</p>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : completedCount === 0
                              ? "#E7E8E9"
                              : "#33C24A2B",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : completedCount === 0
                              ? "#595959"
                              : "#1a6b28",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : completedCount === 0
                                ? "#595959"
                                : "#2C963D",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady
                          ? `${completedCount} Completed`
                          : "0 Completed"}
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : inProgressCount === 0
                              ? "#E7E8E9"
                              : "#BF901826",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : inProgressCount === 0
                              ? "#595959"
                              : "#9a6800",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : inProgressCount === 0
                                ? "#595959"
                                : "#E4A400",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady
                          ? `${inProgressCount} In Progress`
                          : "0 In Progress"}
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : assignedCount === 0
                              ? "#E7E8E9"
                              : "transparent",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : assignedCount === 0
                              ? "#595959"
                              : "#E4A400",
                          border: !isDataReady
                            ? "none"
                            : assignedCount === 0
                              ? "none"
                              : "1px solid #E4A400",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : assignedCount === 0
                                ? "#595959"
                                : "#E4A400",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady ? `${assignedCount} Assigned` : "0 Assigned"}
                      </span>
                    </div>
                    <Badge
                      count={filterCount}
                      className="badg"
                      style={{ marginRight: "20px" }}
                    >
                      <Avatar
                        shape="circle"
                        size="small"
                        src={FilterIcon}
                        className="filterstyle"
                        onClick={handleclickme}
                        style={{ marginRight: "20px" }}
                      />
                    </Badge>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row gutter={16}>
                <Col xs={24} xl={24}>
                  <div className="consingment_container">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <p style={{ margin: 0 }}>{total} Trips</p>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : completedCount === 0
                              ? "#E7E8E9"
                              : "#33C24A2B",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : completedCount === 0
                              ? "#595959"
                              : "#1a6b28",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : completedCount === 0
                                ? "#595959"
                                : "#2C963D",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady
                          ? `${completedCount} Completed`
                          : "0 Completed"}
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : inProgressCount === 0
                              ? "#E7E8E9"
                              : "#BF901826",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : inProgressCount === 0
                              ? "#595959"
                              : "#9a6800",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : inProgressCount === 0
                                ? "#595959"
                                : "#E4A400",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady
                          ? `${inProgressCount} In Progress`
                          : "0 In Progress"}
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          background: !isDataReady
                            ? "#E7E8E9"
                            : assignedCount === 0
                              ? "#E7E8E9"
                              : "transparent",
                          borderRadius: "20px",
                          padding: "3px 10px",
                          fontSize: "12px",
                          color: !isDataReady
                            ? "#595959"
                            : assignedCount === 0
                              ? "#595959"
                              : "#E4A400",
                          border: !isDataReady
                            ? "none"
                            : assignedCount === 0
                              ? "none"
                              : "1px solid #E4A400",
                        }}
                      >
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            background: !isDataReady
                              ? "#A8A8A8"
                              : assignedCount === 0
                                ? "#595959"
                                : "#E4A400",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {isDataReady ? `${assignedCount} Assigned` : "0 Assigned"}
                      </span>
                    </div>
                    <div className="consingment_container_two">
                      {window.innerWidth >= 320 &&
                      window.innerWidth <= 426 ? null : (
                        <div className="Custom">
                          <Tooltip
                            title="Export"
                            placement="bottom"
                            visible={visibleExport}
                            onVisibleChange={handleTooltipVisibleChangeExport}
                            overlayInnerStyle={{
                              backgroundColor: "transparent",
                              color: "#5f6d8c",
                              boxShadow: "none",
                              padding: "0",
                            }}
                          >
                            <Spin spinning={CSVLoader}>
                              <Tooltip
                                title={!exportAllowed ? "No permission" : ""}
                              >
                                <img
                                  src={ExportIcon}
                                  alt="Export"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                    marginRight: "40px",
                                    backgroundColor: "#EBF7ED",
                                    borderRadius: "6px",
                                  }}
                                  onClick={() => {
                                    if (!exportAllowed) return;
                                    prepareCSV();
                                  }}
                                />
                              </Tooltip>
                            </Spin>
                            <CSVLink
                              data={CSVList}
                              filename={"Trips.csv"}
                              asyncOnClick={true}
                              ref={csvLinkEl}
                            />
                          </Tooltip>
                        </div>
                      )}
                      {window.innerWidth >= 320 &&
                      window.innerWidth <= 426 ? null : (
                        <div className="Custom">
                          <Tooltip
                            title="Sort Column"
                            placement="bottom"
                            visible={visibleSort}
                            onVisibleChange={handleTooltipVisibleChangeSort}
                            overlayInnerStyle={{
                              backgroundColor: "transparent",
                              color: "#5f6d8c",
                              boxShadow: "none",
                              padding: "0",
                            }}
                          >
                            <Popover content={content} trigger="click">
                              <img
                                src={SortIcon}
                                alt="Sort"
                                style={{
                                  width: "20px",
                                  height: "25px",
                                  cursor: "pointer",
                                  marginRight: "30px",
                                  backgroundColor: "#EBF7ED",
                                  borderRadius: "6px",
                                }}
                                onClick={(e) => e.preventDefault()}
                              />
                            </Popover>
                          </Tooltip>
                        </div>
                      )}
                      <Badge
                        count={filterCount}
                        className="badg"
                        style={{ marginRight: "20px" }}
                      >
                        <Avatar
                          shape="circle"
                          size="small"
                          src={FilterIcon}
                          className="filterstyle"
                          onClick={handleclickme}
                          style={{ marginRight: "20px" }}
                        />
                      </Badge>
                      {window.innerWidth >= 320 &&
                      window.innerWidth <= 426 ? null : (
                        <ButtonOutlined
                          onClick={() => setIsconfigModalVisible(true)}
                          className="Create_btn"
                        >
                          Configure
                        </ButtonOutlined>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </WrapperBox>
          <UIModal
            className="modal_updatable"
            width={500}
            open={isDeleteModalVisible}
            onClose={() => {
              setIsDeleteModalVisible(false);
              setDeleteId(null); // Reset the delete ID
            }}
            closeButton={false}
            size="md"
            header={false}
            footer={false}
          >
            <div className="text-center">
              <h1>Are you sure,</h1>
              <h6>You want to delete this Trip?</h6>
              <div className="mt-2 w-100 d-flex justify-content-center">
                <ButtonFilled
                  loading={deleteloading}
                  onClick={() => {
                    handleclickdeleteAi(deleteId); // Call the delete function with the selected ID
                  }}
                >
                  Yes
                </ButtonFilled>
                <Buttontransparent
                  onClick={() => {
                    setIsDeleteModalVisible(false); // Close the modal
                    setDeleteId(null); // Reset the delete ID
                  }}
                >
                  No
                </Buttontransparent>
              </div>
            </div>
          </UIModal>
          <TableStyle>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <div>
                  <Spin spinning={loading}>
                    <StyledTable
                      className=""
                      pagination={false}
                      dataSource={tripList}
                      columns={displayedColumns}
                      onRow={(record) => ({
                        onMouseEnter: () => handleClickme(record),
                        onMouseLeave: () => setHoveredrow(null),
                        onClick: (e) => {
                          e.stopPropagation();
                          setConsignee(true);
                          setTripId(record?.TRIPID);
                          setSelectededittwo(record);
                        },
                      })}
                    />
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>
              </Col>
            </Row>
          </TableStyle>

          <UIModal
            width={600}
            height={600}
            open={isconfigModalVisible}
            onClose={() => {
              setIsconfigModalVisible(false);
            }}
            closeButton={false}
            size="md"
            header={
              <div className="text-start">
                <h2>Customized Column</h2>
                <label
                  style={{
                    marginBottom: 8,
                    display: "block",
                    color: "#5F6D8C",
                  }}
                >
                  Columns
                </label>
              </div>
            }
            footer={
              <div className="mt-2 w-100 d-flex justify-content-end">
                <ButtonFilled
                  onClick={() => {
                    setIsconfigModalVisible(false); // Close the modal
                  }}
                >
                  Save
                </ButtonFilled>
                <Buttontransparent
                  onClick={() => {
                    setIsconfigModalVisible(false); // Just close the modal
                  }}
                >
                  Cancel
                </Buttontransparent>
              </div>
            }
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select custom columns"
              value={selectedColumns}
              onChange={setSelectedColumns}
              dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
              dropdownRender={(menu) => (
                <div>
                  <Checkbox.Group
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "8px 12px",
                    }}
                    value={selectedColumns}
                    onChange={setSelectedColumns}
                  >
                    {allColumnOptions.map((option) => (
                      <Checkbox
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </div>
              )}
            >
              {allColumnOptions.map((option) => (
                <Select.Option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </UIModal>
        </>
      )}

      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => setDrawerOpen(false)}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              key="create"
              type="primary"
              loading={loading}
              onClick={() => form?.submit()}
            >
              {isEditing ? "Update" : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>Modifying Trip</p>

                <span>
                  <CloseOutlined onClick={() => setDrawerOpen(false)} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChangeedit}
                formSubmit={edittrip}
                initialValues={editformdata}
                form={form}
                handleSelectChange={editSelectChange}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
    </>
  );
};

export default TripList1;
